export default __webpack_public_path__ + "static/media/TZ.f30bcdc3.ico";